/** Values that both the API and the Web application must agree on. */
export const PLATFORM_TYPES = ["WHATSAPP", "INSTAGRAM", "FACEBOOK"];
export const ORGANIZATION_MEMBER_ROLES = ["OWNER", "ADMIN", "AGENT"];
/** V1 organization lifecycle. CLOSED was removed in Order 36A. */
export const ORGANIZATION_STATUSES = ["ACTIVE", "SUSPENDED"];
export const CONVERSATION_STATUSES = ["OPEN", "PENDING", "CLOSED", "ARCHIVED"];
/** Status values the Inbox workflow API accepts. PENDING and ARCHIVED are not writers. */
export const CONVERSATION_WORKFLOW_STATUSES = ["OPEN", "CLOSED"];
export const MESSAGE_STATUSES = [
    "RECEIVED",
    "PENDING",
    "SENDING",
    "SENT",
    "DELIVERED",
    "READ",
    "FAILED",
];
export const MESSAGE_TYPES = [
    "TEXT",
    "IMAGE",
    "VIDEO",
    "AUDIO",
    "DOCUMENT",
    "LOCATION",
    "CONTACT",
    "STICKER",
    "INTERACTIVE",
    "UNKNOWN",
];
/**
 * Durable outbound Message producer (Order 31A). Separate from Direction and Platform.
 * Inbound Messages leave origin null. Historical unclassified rows may also be null.
 */
export const MESSAGE_ORIGINS = [
    "INBOX",
    "CAMPAIGN",
    "CAMPAIGN_SEND_TEST",
    "SYSTEM",
    "AI_AGENT",
    "AUTOMATION",
    "API",
    "MOBILE_APP",
];
/** Report/API direction dimension (derived; not a Prisma column in Order 31A). */
export const MESSAGE_DIRECTIONS = ["INBOUND", "OUTBOUND"];
/**
 * Mutually exclusive Outgoing report status buckets (Order 31B).
 * PROCESSING aggregates in-flight Message statuses — not a Prisma enum value.
 */
export const REPORT_MESSAGE_STATUS_BUCKETS = [
    "PROCESSING",
    "SENT",
    "DELIVERED",
    "READ",
    "FAILED",
];
/** Message.status values that map to the Outgoing report PROCESSING card.
 * RECEIVED is inbound-only and must not appear here.
 */
export const REPORT_PROCESSING_MESSAGE_STATUSES = [
    "PENDING",
    "SENDING",
];
/** Conversation list activity sorts. Default is newest activity first. */
export const CONVERSATION_LIST_SORTS = ["activity_desc", "activity_asc"];
export const DEFAULT_CONVERSATION_LIST_SORT = "activity_desc";
/**
 * Conversation-list contact-state filter. Maps onto derived ContactState:
 * SAVED = ACTIVE; UNSAVED = NOT_SAVED or DELETED. Not a database enum.
 */
export const CONVERSATION_LIST_CONTACT_STATES = ["SAVED", "UNSAVED"];
/**
 * Single-select Inbox list view (Order 38, revised D7).
 * Open/Closed is a separate status filter, not a view.
 */
export const CONVERSATION_LIST_VIEWS = ["ALL", "MINE", "UNASSIGNED"];
export const DEFAULT_CONVERSATION_LIST_VIEW = "ALL";
/**
 * Independent conversation status filter. Combines with view.
 * OPEN includes legacy PENDING. CLOSED includes legacy ARCHIVED.
 */
export const CONVERSATION_LIST_STATUSES = ["ALL", "OPEN", "CLOSED"];
export const DEFAULT_CONVERSATION_LIST_STATUS = "ALL";
export const CONVERSATION_EVENT_TYPES = [
    "ASSIGNED",
    "REASSIGNED",
    "UNASSIGNED",
    "CLOSED",
    "REOPENED",
];
export const CONVERSATION_EVENT_ACTOR_TYPES = [
    "ORGANIZATION_MEMBER",
    "PLATFORM_ADMIN",
    "SYSTEM",
];
export const CONVERSATION_EVENT_REASONS = ["MEMBER_REMOVED", "CUSTOMER_INBOUND"];
export const HEALTH_PATH = "/health";
export const READINESS_PATH = "/ready";
//# sourceMappingURL=constants.js.map